import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "my-grade" }
const _hoisted_2 = { class: "my-grade__details-row" }
const _hoisted_3 = { class: "my-grade__details" }
const _hoisted_4 = { class: "my-grade__details-percent my-grade__details-percent--current" }
const _hoisted_5 = { class: "my-grade__details-desc" }
const _hoisted_6 = {
  key: 0,
  class: "my-grade__details"
}
const _hoisted_7 = { class: "my-grade__details-percent" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://object.pscloud.io/loyalty/grading-front/arrow-icon.svg",
  alt: "arrow"
}, null, -1)
const _hoisted_9 = { class: "my-grade__details-desc" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "my-grade__details-last-level"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://object.pscloud.io/loyalty/grading-front/guard-icon.svg",
  alt: "save"
}, null, -1)
const _hoisted_13 = { class: "my-grade__details-desc" }
const _hoisted_14 = {
  key: 1,
  class: "my-grade__details-last-level"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://object.pscloud.io/loyalty/grading-front/save-icon.svg",
  alt: "save"
}, null, -1)
const _hoisted_16 = { class: "my-grade__details-desc" }
const _hoisted_17 = {
  key: 1,
  class: "my-grade__total"
}
const _hoisted_18 = {
  key: 2,
  class: "my-grade__total"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "my-grade__total-amount" }
const _hoisted_26 = {
  key: 3,
  class: "my-grade__total"
}
const _hoisted_27 = { class: "my-grade__percents-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_GradePercent = _resolveComponent("GradePercent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentLevelIndex) + "% ", 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('myGrade.yourCashback')), 1)
      ]),
      (!_ctx.checkIfLastLevel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.findNextGradeLevel || 0) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('myGrade.nextGrade')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.pointsToSave && _ctx.currentThreshold !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('myGrade.letsSaveLevel')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.points >= _ctx.currentThreshold)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('myGrade.levelWasSaved')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (_ctx.nextThreshold && _ctx.remainingPointsToNextLevel || _ctx.remainingPointsToNextLevel === 0)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          partialValue: (Number(_ctx.nextThreshold) - Number(_ctx.remainingPointsToNextLevel)) ?? 0,
          totalValue: Number(_ctx.nextThreshold) ?? 0
        }, null, 8, ["partialValue", "totalValue"]))
      : _createCommentVNode("", true),
    (!_ctx.downgradeDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('myGrade.activateLevel')), 1))
      : _createCommentVNode("", true),
    (_ctx.downgradeDate && !_ctx.checkIfLastLevel || _ctx.downgradeDate && _ctx.checkIfLastLevel && _ctx.pointsToSave && _ctx.currentThreshold !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.currentLang === 'ru')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(_ctx.$t('myGrade.tillRu')) + " " + _toDisplayString(_ctx.downgradeDateFormatted) + " ", 1),
                (_ctx.leftDaysString)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(" + _toDisplayString(_ctx.leftDaysString) + ")", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (!_ctx.leftDaysString)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(_ctx.$t('myGrade.today')) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentLang === 'kk')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createTextVNode(_toDisplayString(_ctx.downgradeDateFormatted) + " " + _toDisplayString(_ctx.$t('myGrade.tillKz')) + " ", 1),
                (_ctx.daysBeforeLevelBurnsDown)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(" + _toDisplayString(_ctx.daysBeforeLevelBurnsDown) + " " + _toDisplayString(_ctx.$t('details.days')) + ")", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.daysBeforeLevelBurnsDown === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "(" + _toDisplayString(_ctx.$t('myGrade.today')) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.nextThreshold), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.downgradeDate && _ctx.checkIfLastLevel && _ctx.points >= _ctx.currentThreshold)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('myGrade.youSavedLevelTill1')) + " " + _toDisplayString(_ctx.downgradeDateFormatted) + " " + _toDisplayString(_ctx.$t('myGrade.youSavedLevelTill2')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLevels, (percent) => {
        return (_openBlock(), _createBlock(_component_GradePercent, {
          key: percent.id,
          gradePercent: percent.value,
          partialValue: _ctx.nextThreshold - _ctx.remainingPointsToNextLevel,
          totalValue: _ctx.nextThreshold,
          class: _normalizeClass({
          'my-grade__grade-current-saved': percent.value === _ctx.currentLevelIndex && _ctx.points >= _ctx.currentThreshold && percent.threshold !== 0,
          'my-grade__grade-current': percent.value === _ctx.currentLevelIndex && _ctx.points < _ctx.currentThreshold ||
            (percent.threshold === 0 && percent.value === _ctx.currentLevelIndex),
          'my-grade__grade-next': percent.value === _ctx.findNextGradeLevel,
          'my-grade__grade-lock':
            _ctx.findLockedGradeLevels?.filter((e) => e === percent.value).length >
            0,
          'my-grade__grade-prev':
            _ctx.findPrevGradeLevels?.filter((e) => e === percent.value).length > 0,
        })
        }, null, 8, ["gradePercent", "partialValue", "totalValue", "class"]))
      }), 128))
    ])
  ]))
}